function resolveApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL?.trim() || "/api";
  const normalized = raw.replace(/\/+$/, "");
  if (normalized === "/api" || normalized.endsWith("/api")) return normalized;
  // Production worker URL is the host root; API routes live under /api.
  if (/^https?:\/\//.test(normalized)) return `${normalized}/api`;
  return normalized;
}

export const API_BASE_URL = resolveApiBaseUrl();

export async function apiFetch<T = unknown>(
  path: string,
  options: RequestInit & { token?: string | null } = {},
): Promise<T> {
  const { token: tokenOption, ...rest } = options;
  const token = Object.prototype.hasOwnProperty.call(options, "token")
    ? tokenOption
    : localStorage.getItem("authToken");

  const headers: Record<string, string> = {
    ...(rest.headers as Record<string, string> | undefined),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const isFormData = typeof FormData !== "undefined" && rest.body instanceof FormData;
  if (isFormData && headers["Content-Type"]) delete headers["Content-Type"];

  const response = await fetch(`${API_BASE_URL}${path}`, { ...rest, headers });
  const text = await response.text();
  let data: T | { error?: string } | null = null;
  if (text) {
    try {
      data = JSON.parse(text) as T;
    } catch {
      /* non-json */
    }
  }

  if (!response.ok) {
    if (response.status === 401 && token) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("authUser");
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    const message =
      (data && typeof data === "object" && "error" in data && data.error) ||
      `Request failed (${response.status})`;
    throw new Error(String(message));
  }

  return data as T;
}

export function downloadUrl(path: string): string {
  const token = localStorage.getItem("authToken");
  return `${API_BASE_URL}${path}${token ? `?token=${encodeURIComponent(token)}` : ""}`;
}
